import {
  blackColor,
  primaryColor,
  primaryBoxShadow,
  dangerColor,
  successColor,
  defaultFont,
  grayColor,
  lightGrayColor,
} from 'assets/styles/jss/main';

export default {
  root: {
    paddingBottom: 10,
  },
  disabled: {
    '&:before': {
      background: 'transparent !important',
      backgroundSize: '3px 1px !important',
      backgroundImage: 'linear-gradient(to right, rgba(0, 0, 0, 0.23) 33%, transparent 0%) !important',
      backgroundRepeat: 'repeat-x !important',
      backgroundPosition: 'left top !important',
    },
  },
  select: {
    textAlign: 'left',
    color: blackColor,
    fontSize: '16px',
    fontWeight: '400',
    padding: '2px 25px 2px 12px',
    height: '36px',
    lineHeight: '36px',
    border: '2px solid #ececee',
    background: lightGrayColor,
    borderRadius: '5px',
    '&[aria-owns] + input + svg': {
      transform: 'rotate(180deg)',
    },
    '& + input + svg': {
      transition: 'all 300ms linear',
    },
    '&:focus': {
      borderRadius: '5px',
    },
  },
  selectLabel: {
    ...defaultFont,
    position: 'relative !important',
    color: `${blackColor} !important`,
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '22px',
    transform: 'scale(1)',
    '& + div': {
      marginTop: 10,
    },
  },
  selectMenu: {
    '& > div': {
      boxSizing: 'borderBox',
      borderRadius: '0 !important',
      padding: '0',
      minWidth: '100%',
      display: 'block',
      border: '0',
      boxShadow: '0 2px 5px 0 rgba(0, 0, 0, 0.26)',
      backgroundClip: 'padding-box',
      margin: '1px 0 0',
      fontSize: '16px',
      textAlign: 'left',
      listStyle: 'none',
      backgroundColor: 'transparent',
    },
    '& > div > ul': {
      border: 0,
      borderRadius: '0 !important',
      padding: '5px 0',
      margin: '0',
      boxShadow: 'none',
      minWidth: '100%',
      boxSizing: 'border-box',
      display: 'block',
      fontSize: '16px',
      textAlign: 'left',
      listStyle: 'none',
      backgroundColor: '#fff',
      backgroundClip: 'padding-box',
    },
  },
  selectMenuPlaceholder: {
    color: grayColor,
  },
  selectMenuItem: {
    fontSize: '13px',
    padding: '10px 20px',
    margin: '0 5px',
    transition: 'all 150ms linear',
    display: 'block',
    clear: 'both',
    fontWeight: '400',
    lineHeight: '2',
    whiteSpace: 'nowrap',
    color: '#333',
    '&:hover': {
      backgroundColor: primaryColor,
      color: '#FFFFFF',
      ...primaryBoxShadow,
    },
  },
  selectMenuItemSelected: {
    backgroundColor: `${primaryColor}!important`,
    color: '#FFFFFF',
  },
  selectError: {
    borderColor: dangerColor,
    transition: '0.3s ease all',
  },
  selectSuccess: {
    borderColor: successColor,
    transition: '0.3s ease all',
  },
  labelRoot: {
    position: 'relative !important',
    color: `${blackColor}!important`,
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '22px',
  },
  labelRootError: {
    color: `${dangerColor}!important`,
  },
  labelRootSuccess: {
    color: `${successColor}!important`,
  },
  feedback: {
    position: 'absolute',
    bottom: 23,
    right: 23,
    zIndex: 2,
    display: 'block',
    width: 24,
    height: 24,
    textAlign: 'center',
    pointerEvents: 'none',
  },
  selected: {
    '@media (max-width: 767px)': {
      minWidth: '150px',
    },
    '@media (min-width: 768px)': {
      minWidth: '200px',
    },
    '@media (min-width: 992px)': {
      minWidth: '120px',
    },
  },
  customLabel: {
    //...customFont
  },
};
